import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import LoadingButton from '@shared/components/LoadingButton';
export default function NomenclaturesOzForm({ onClose, editData, handleConfirm, selectedNomenclature }) {
    const modalRef = useRef(null);
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const validationSchema = yup.object().shape({
        code: yup.string().required(t('common.required')),
        bgName: yup.string().required(t('common.required')),
        enName: yup.string().required(t('common.required')),
        status: yup.string().required(t('common.required'))
    });

    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const watchedValues = watch();

    useEffect(() => {
        if (editData) {
            setValue('code', editData.code || '');
            setValue('status', editData.active ? '1' : '2');

            // Extract language names from nomenclatureItemLngs
            if (editData.nomenclatureItemLngs && editData.nomenclatureItemLngs.length > 0) {
                const bgLang = editData.nomenclatureItemLngs.find(lng => lng.languages?.language === 'bg_BG');
                const enLang = editData.nomenclatureItemLngs.find(lng => lng.languages?.language === 'en_US');

                setValue('bgName', bgLang?.name || '');
                setValue('enName', enLang?.name || '');

            } else {
                setValue('bgName', editData.nameBg || editData.name || '');
                setValue('enName', editData.nameEn || '');
            }
        }
    }, [editData, setValue]);
    const handleClose = () => {
        onClose();
    }

    const submitForm = async (data) => {
        setLoading(true);
        try {
            const formData = {
                code: data.code,
                active: data.status === '1',
                nameBg: data.bgName,
                nameEn: data.enName
            };

            if (!editData) {
                formData.nomenclatureId = selectedNomenclature;
            }

            if (handleConfirm) {
                await handleConfirm(formData);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={handleClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {editData ? t('common.edit') : t('organizationalStructure.nomenclatures.form.title')}
                        </h4>
                        <form id="nomenclaturesOzForm" className="region-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="flex-column">
                                <div className="form-section width-90">
                                    <div className="form-group">
                                        <span className="span-bold">{t('organizationalStructure.nomenclatures.form.code')}<span className="required">*</span></span>
                                        <input
                                            maxLength={50}
                                            type="text"
                                            className="form-control"
                                            {...register('code')}
                                        />
                                        {errors.code && <p className="error-message compact">{errors.code.message}</p>}
                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('organizationalStructure.nomenclatures.form.bgName')}<span className="required">*</span></span>
                                        <input
                                            maxLength={100}
                                            type="text"
                                            className="form-control"
                                            {...register('bgName')}
                                            value={watchedValues.bgName || ''}
                                        />
                                        {errors.bgName && <p className="error-message compact">{errors.bgName.message}</p>}
                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('organizationalStructure.nomenclatures.form.enName')}<span className="required">*</span></span>
                                        <input
                                            maxLength={100}
                                            type="text"
                                            className="form-control"
                                            {...register('enName')}
                                            value={watchedValues.enName || ''}
                                        />
                                        {errors.enName && <p className="error-message compact">{errors.enName.message}</p>}
                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('organizationalStructure.nomenclatures.form.status')}</span>
                                        <select
                                            className="small-select"
                                            {...register('status', { required: true })}
                                            value={watchedValues.status || '1'}
                                        >
                                            <option value="1">{t('organizationalStructure.jobDescriptions.form.active')}</option>
                                            <option value="2">{t('organizationalStructure.jobDescriptions.form.inactive')}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <LoadingButton type="submit" className="btn btn-primary" loading={loading} disabled={loading}>{t('common.save')}</LoadingButton>
                                <button type="button" className="btn btn-secondary" onClick={handleClose} disabled={loading}>
                                    {t('common.cancel')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}